<div
  (click)="$event.stopPropagation(); onPress.emit($event)"
  class="more-details-btn"
>
  More details
</div>
